import React, { useState, useEffect } from "react";
// import { Flex, TextField } from "@digitallabs/one-x-ui";
import { Flex, TextField } from "../../../resourses/digitallabs/one-x-ui";
import "../../../styles/DynamicFormRenderer_Helix.css";
import { showCatchError } from "../../../utils/toastMessageUtil";
import { validateSecureInput } from "../../../utils/inputCheckUtility";

const DynamicInputHeightConvertor = ({
  field,
  fieldName,
  value,
  isMain,
  step,
  fieldRefs,
  updateValue,
  renderLabelWithPrefix,
  fieldIsRequired,
  validateSingleField,
  validateVisible,
  setErrors,
  setIsValid,
  onFormValidityChange,
  submitted,
  errors,
  maxLength,
}) => {
  let disabled = !!field.default_answer;

  const safeValue = typeof value === "string" || typeof value === "number" ? value : "";

  const inputValue = field.default_answer ?? String(safeValue);

  const [heightFeet, setHeightFeet] = useState("");

  const convertHeight = (cm) => {
    if (!cm) return "";

    const cmValue = Number(cm);
    if (isNaN(cmValue) || cmValue <= 0) return "";

    const totalInches = cmValue / 2.54;
    const feet = Math.floor(totalInches / 12);
    const inches = Math.round(totalInches % 12);

    return `${feet} feet ${inches} inches`;
  };

  useEffect(() => {
    if (value) {
      const converted = convertHeight(value);
      setHeightFeet(converted);
    } else {
      setHeightFeet("");
    }
  }, [value]);

  return (
    <Flex key={fieldName} direction="column" gap="xs" className="dfh-field-wrapper" ref={(el) => (fieldRefs.current[fieldName] = el)}>
      <TextField
        value={inputValue}
        computedValue={heightFeet ? heightFeet : null}
        placeholder="Enter"
        variant="outline"
        size="md"
        label={{
          label: renderLabelWithPrefix(isMain, field.question, step),
          optional: !fieldIsRequired(field),
        }}
        maxLength={maxLength ?? undefined}
        disabled={disabled}
        onBlur={() => {
          if (!validateSecureInput(inputValue)) {
            showCatchError(field.question ? `Invalid input characters in ${field.question}` : "Invalid input characters");
            return;
          }

          const single = validateSingleField(field);
          setErrors((prev) => ({ ...prev, ...single }));

          const validation = validateVisible();
          const valid = Object.keys(validation).length === 0;

          setIsValid(valid);
          if (typeof onFormValidityChange === "function") {
            onFormValidityChange(valid);
          }
        }}
        onChange={(e) => {
          if (!disabled) {
            let val = e.target.value ?? "";

            if (field.rules?.includes("numeric")) {
              val = val.replace(/[^0-9]/g, "");
            }

            const formatted = val.length > 0 ? val.charAt(0).toUpperCase() + val.slice(1) : "";

            updateValue(fieldName, formatted);

            const converted = convertHeight(val);
            setHeightFeet(converted);
          }
        }}
        helperText={submitted && errors[fieldName] ? { message: errors[fieldName], status: "error" } : undefined}
      />

      {field.info_text && <div className="dfh-info-text">{field.info_text}</div>}
    </Flex>
  );
};

export default DynamicInputHeightConvertor;
